export default __webpack_public_path__ + "static/media/quadruped.5ec4558a.png";